module.exports = __webpack_public_path__ + "communicate.svg?279334b8564e53354426010e55216251";


//////////////////
// WEBPACK FOOTER
// ./public/img/home/communicate.svg
// module id = 551
// module chunks = 0